import ColorHash from 'color-hash-ts';

import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { colors } from 'design';

export type SymptomsChartProps = {
  dayValues: string[][];
  translationKeyPrefix?: string;
  colorMap?: Record<string, string>;
  // overrides the default colour dot with a custom icon for specific values (e.g. an X instead of a
  // colour, for a "none" option that a colour swatch can't represent on its own)
  iconMap?: Record<string, React.ReactNode>;
};

const useStyles = createUseStyles({
  symptomLegend: {
    margin: '0px 12px 0px 0px',
    display: 'inline-flex',
    alignItems: 'center',
    color: colors.text.disabled,
  },
  symptomLegendDot: {
    height: 8,
    width: 8,
    display: 'inline-block',
    marginRight: 4,
    borderRadius: '50%',
  },
});

const SymptomsChart: React.FC<SymptomsChartProps> = ({
  dayValues,
  translationKeyPrefix = 'symptomTracking.survey.symptoms',
  colorMap,
  iconMap,
}) => {
  const { t } = useTranslation();
  const colorHash = new ColorHash();

  const styles = useStyles();

  const allSymptoms = new Set<string>();
  dayValues.forEach(daySymptoms => {
    daySymptoms.forEach(symptom => allSymptoms.add(symptom));
  });

  return (
    <div>
      {Array.from(allSymptoms)
        .sort()
        .reverse()
        .map(symptom => (
          <span className={styles.symptomLegend} key={symptom}>
            {iconMap?.[symptom] ?? (
              <div
                className={styles.symptomLegendDot}
                style={{ backgroundColor: colorMap?.[symptom] ?? colorHash.hex(symptom) }}
              />
            )}
            {t(`${translationKeyPrefix}.${symptom}`)}
          </span>
        ))}
    </div>
  );
};
export default SymptomsChart;
